import React from 'react';
import '../styles/Legal.css';
import usePageMeta from "../hooks/usePageMeta";

const LAST_UPDATED = 'January 9, 2026';

const PrivacyRequestsPage: React.FC = () => {
  usePageMeta({
    title: "Privacy Requests | PabSync",
    description:
      "Request access to, deletion of, or export of your personal information.",
    path: "/privacy-requests",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Privacy Requests</h1>
          <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

          <p>
            You may request access to, deletion of, or export of certain personal information, subject to verification
            and applicable law.
          </p>

          <h2>How to submit a request</h2>
          <ul>
            <li>Email <a href="mailto:datacare@pabsync.com">datacare@pabsync.com</a> from the address associated with your account.</li>
            <li>Include the type of request (access, deletion, export) and any relevant details.</li>
          </ul>

          <h2>Verification</h2>
          <p>
            To protect your account, we may ask you to verify your identity before completing a request.
          </p>

          <h2>Related pages</h2>
          <p>
            See our <a href="/privacy">Privacy Statement</a> and <a href="/security">Security</a>.
          </p>

          <p className="legal-note">
            This page is provided for general informational purposes and may be updated from time to time.
          </p>
        </article>
      </main>
    </div>
  );
};

export default PrivacyRequestsPage;
